(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Livia_homepage_v4"]) return;
  try {
    
$(document).ready(function(){

$('.lh-skeptics-galery').slick({
    dots: false,
    arrows: true,
    rtl: document.documentElement.dir === 'rtl',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,     // דסקטופ – נשאר
    centerPadding: '0px', // בלי פדינג בדסקטופ

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerMode: false,
          centerPadding: '0px'
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '0px'
        }
      },
      {
        breakpoint: 676,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '0px'
        }
      }
    ]
  });
});


    document.addEventListener('DOMContentLoaded', function () {
    var counters = document.querySelectorAll('.lh-counter');

    if (!('IntersectionObserver' in window)) {
      // דפדפנים ישנים – פשוט להציג את המספרים בלי אנימציה
      counters.forEach(function (el) {
        el.textContent = el.dataset.target + '%';
      });
      return;
    }

    function animateCounter(el) {
      var target = parseInt(el.dataset.target, 10);
      var duration = 1500; // כמה זמן האנימציה (ms)
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var value = Math.floor(progress * target);
        el.textContent = value + '%';

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          el.textContent = target + '%'; // לוודא שמסיים במספר המדויק
        }
      }

      window.requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          obs.unobserve(entry.target); // שלא ירוץ שוב
        }
      });
    }, {
      threshold: 0.4 // האנימציה תתחיל כש ~40% מהאלמנט על המסך
    });

    counters.forEach(function (el) {
      observer.observe(el);
    });
  });


// כש לוחצים על התמונה של הפס – לעבור לשקופית הבאה בגלריית ה-UGC
document.addEventListener('DOMContentLoaded', function () {
  var nextButtons = document.querySelectorAll('.js-ugc-next');
  if (!nextButtons.length) return;

  nextButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {

      // 1) קודם נגלול קצת למעלה לתחילת הסקשן של TRUSTED
      var section = btn.closest('.lh-trusted');
      if (section) {
        var rect = section.getBoundingClientRect();
        var scrollTop = window.pageYOffset + rect.top - 80; // תשחק עם 80px אם צריך יותר/פחות
        window.scrollTo({
          top: scrollTop,
          behavior: 'smooth'
        });
      }

      // 2) אחרי הגלילה – מפעילים את ה-next הקיים של הסליידר
      setTimeout(function () {
        var scope = section || document;
        var nextArrow;

        // במובייל – נעדיף את הסליידר של המובייל אם יש
        if (window.matchMedia('(max-width: 989px)').matches) {
          nextArrow =
            scope.querySelector('.Mobile_only .slick-next') ||
            scope.querySelector('.slick-next');
        } else {
          // בדסקטופ – נעדיף את הדסקטופ
          nextArrow =
            scope.querySelector('.Desktop_only .slick-next') ||
            scope.querySelector('.slick-next');
        }

        if (nextArrow) {
          nextArrow.click(); // משתמשים בלחצן next הקיים של הסליידר
        }
      }, 80); // דיליי קטן כדי שהגלילה תתחיל
    });
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Livia_main_product_new"]) return;
  try {
    
/**
 * Livia product – sync button + images (KIT/SUB) + fallback image for old ATC
 */
document.addEventListener('DOMContentLoaded', function () {
  // -------- helpers --------
  function q(sel, root){ return (root||document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }

  function getActiveCard(){
    // תומך גם ב-active וגם ב-is-active כדי לא לשבור קוד ישן
    return q('.Livia_delivery_mode_switch.is-active') || q('.Livia_delivery_mode_switch.active');
  }

  function getActiveMode(){
    var card = getActiveCard();
    return card?.getAttribute('data') || card?.getAttribute('data-mode') || 'onetime';
  }

  // -------- sync button from active card --------
  function syncButtonFromActiveCard(){
    var btn  = q('#lv_tr_atc_one-time-purchase');
    var card = getActiveCard();
    if (!btn || !card) return;

    var mode  = card.getAttribute('data') || card.getAttribute('data-mode') || 'onetime';
    btn.setAttribute('data-mode', mode);

    if (mode === 'autodelivery') {
      var planId = card.getAttribute('data-plan-id') || card.getAttribute('data-value') || '';
      var sellId = card.getAttribute('data-selling-plan-id') || '';

      if (planId){
        btn.setAttribute('data-value', planId);
        btn.setAttribute('data-plan-id', planId);
      }
      if (sellId){
        btn.setAttribute('data-selling-plan-id', sellId);
      }
      if (!btn.getAttribute('data-subText-sub')){
        btn.setAttribute('data-subText-sub', 'Membership, Every 6 months');
      }
    } else {
      // one-time
      btn.removeAttribute('data-selling-plan-id');
      if (!btn.getAttribute('data-subText-onetime')){
        btn.setAttribute('data-subText-onetime', 'one-time');
      }
    }
  }

  // -------- images handling (KIT + SUB + fallback) --------
  // ids אפשריים בגלריות הכרטיסיות:
  //  - KIT: #livia-card-img-onetime (או #livia-card-img כגיבוי)
  //  - SUB: #livia-card-img-sub
  //  - Fallback ישן לכפתור ה-ATC הישן: #lv-fallback-main-img
  var imgKit = q('#livia-card-img-onetime') || q('#livia-card-img'); // תמונת ה-KIT
  var imgSub = q('#livia-card-img-sub');                              // תמונת ה-SUB (אם קיימת)
  var imgFb  = q('#lv-fallback-main-img');                            // תמונת fallback שהקוד הישן קורא ממנה

  function updateImagesForCell(cell){
    if (!cell) return;

    // urls שמגיעים מה־data על תא הצבע
    var k = (cell.getAttribute('data-card-image-kit') || '').trim();
    var s = (cell.getAttribute('data-card-image-sub') || '').trim();
    if (!s) s = k; // אם אין תמונת מנוי ייעודית – נשתמש בזו של ה-KIT

    if (imgKit && k) imgKit.src = k;
    if (imgSub && s) imgSub.src = s;

    // לעדכן את ה-fallback לפי מצב הטאב הפעיל
    if (imgFb){
      var mode = getActiveMode();
      imgFb.src = (mode === 'autodelivery') ? (s || k) : (k || s);
    }
  }



// -------- wire up: color cells --------
var colorCells = qa('.Livia_product_color_selector_cell');
var modeSwitches = qa('.Livia_delivery_mode_switch');

colorCells.forEach(function(cell){
  cell.addEventListener('click', function(){

    // 1. active/is-active על כפתורי צבע
    colorCells.forEach(function(c){
      c.classList.remove('is-active');
      c.classList.remove('active');
    });
    cell.classList.add('is-active');
    cell.classList.add('active');

    // 2. צבע מסגרת של כרטיס המוצר
    modeSwitches.forEach(function(sw){
      sw.classList.remove('pink', 'purple', 'lavender', 'blue-green');
    });

    var color = cell.getAttribute('data-title'); // blue-green / pink / purple / lavender

    if (color === 'blue-green') {
      modeSwitches.forEach(function(sw){ sw.classList.add('blue-green'); });
    } else if (color === 'pink') {
      modeSwitches.forEach(function(sw){ sw.classList.add('pink'); });
    } else if (color === 'lavender') {
      modeSwitches.forEach(function(sw){ sw.classList.add('lavender'); });
    } else if (color === 'purple') {
      modeSwitches.forEach(function(sw){ sw.classList.add('purple'); });
    }

    // 3. עדכון תמונות כרטיס KIT/SUB
    updateImagesForCell(cell);

    // 4. סינון הגלריה לפי הצבע הנבחר
    if (window.jQuery && jQuery.fn && jQuery.fn.slick && color) {
      var $main  = jQuery('.Livia_product_gallery_main');
      var $thumb = jQuery('.Livia_product_gallery_thumb');

      if ($main.length && $main.hasClass('slick-initialized') &&
          $thumb.length && $thumb.hasClass('slick-initialized')) {

        $main.slick('slickUnfilter');
        $thumb.slick('slickUnfilter');

        jQuery('.Livia_product_gallery_slide').removeClass('Filtered_slide');
        jQuery('.Livia_product_gallery_slide').each(function(){
          if (color === jQuery(this).attr('data-color')) {
            jQuery(this).addClass('Filtered_slide');
          }
        });

        $main.slick('slickFilter', '.Filtered_slide');
        $thumb.slick('slickFilter', '.Filtered_slide');
        $main.slick('slickGoTo', 0);
      }
    }
  });
});



  // -------- wire up: tabs (delivery mode cards) --------
  var cards = qa('.Livia_delivery_mode_switch');
  cards.forEach(function(card){
    card.addEventListener('click', function(){
      cards.forEach(function(c){ c.classList.remove('is-active'); c.classList.remove('active'); });
      card.classList.add('is-active'); // נשמור אחידות קדימה
      syncButtonFromActiveCard();

      // עדכון ה-fallback (ושאר התמונות) עבור הצבע הפעיל הנוכחי
      var activeCell = q('.Livia_product_color_selector_cell.is-active') || colorCells[0];
      updateImagesForCell(activeCell);
    });
  });

  // -------- initial state --------
  // אם אין תא מסומן – נסמן את הראשון
  var initialCell = q('.Livia_product_color_selector_cell.is-active') || colorCells[0];
  if (initialCell && !initialCell.classList.contains('is-active')){
    initialCell.classList.add('is-active');
  }
  updateImagesForCell(initialCell);
  syncButtonFromActiveCard();
});

 



// רענון אמיתי כשחוזרים לדף המוצר (מונע עגלה "תקועה" על 0)
/*window.addEventListener('pageshow', function (event) {
  if (event.persisted || (performance.getEntriesByType("navigation")[0]?.type === "back_forward")) {
    window.location.reload(true);
  }
});


document.addEventListener('DOMContentLoaded', function () {
  var btn = document.querySelector('.Livia_main_product_atc');
  if (!btn) return;

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var activeCell = document.querySelector('.Livia_product_color_selector_cell.active');
    if (!activeCell) { location.href = '/checkout'; return; }

    var variantId = Number(activeCell.dataset.id);
    var sellingPlanId = Number(btn.getAttribute('data-selling-plan-id') || btn.getAttribute('data-value') || '');
    var isSubscription = document.querySelector('.Livia_subscription_onetime_switch.is-sub, .Livia_subscription_onetime_switch [aria-pressed="true"]');

    var items = [];
    var mainItem = { id: variantId, quantity: 1 };
    if (isSubscription && sellingPlanId) mainItem.selling_plan = sellingPlanId;
    items.push(mainItem);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(){ location.href = '/checkout'; })
    .catch(function(){ location.href = '/checkout'; });
  }, true);
});
*/


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Livia_main_product_new_A"]) return;
  try {
    
/**
 * Livia product – sync button + images (KIT/SUB) + fallback image for old ATC
 */

// ===== פונקציות עזר גלובליות =====
function initStickyBehavior() {
  console.log('🔧 initStickyBehavior started');
  
  if (window.matchMedia('(min-width: 769px)').matches) {
    console.log('Desktop - skipping sticky');
    return;
  }
  
  var stickyWrapper = document.querySelector('.lv-sticky-wrapper');
  var atcButton = document.querySelector('#lv_tr_atc_one-time-purchase');
  
  if (!stickyWrapper || !atcButton) {
    console.log('❌ Elements not found');
    return;
  }

  // פונקציות לניהול הכפתור
  function disableButton() {
    atcButton.classList.add('is-disabled');
    atcButton.classList.add('is-hidden');
    console.log('❌ Button GRAY');
  }

  function enableButton() {
    atcButton.classList.remove('is-hidden');
    atcButton.classList.remove('is-disabled');
    console.log('✅ Button BLUE');
  }

  // ✅ התחל עם sticky VISIBLE אבל כפתור אפור
  stickyWrapper.style.opacity = '1';
  stickyWrapper.style.visibility = 'visible';
  stickyWrapper.style.transform = 'translateY(0)';
  disableButton();

  var cardsArea = document.querySelector('.Livia_subscription_onetime_switch') || 
                  document.querySelector('.Livia_delivery_mode_switch');
  var faqArea = document.querySelector('.Livia_product_accordion_line') ||
                document.querySelector('.Livia_product_about_outer');

  if (!cardsArea) {
    console.log('❌ Cards area not found');
    return;
  }

  var stickyVisible = true; // מתחיל גלוי

  function checkScroll() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var windowHeight = window.innerHeight;
    var cardsTop = cardsArea.getBoundingClientRect().top + scrollTop;
    var faqTop = faqArea ? (faqArea.getBoundingClientRect().top + scrollTop) : Infinity;
    
    var scrolledEnough = scrollTop > 200;
    var reachedCards = scrollTop + windowHeight > cardsTop + 100;
    var reachedFaq = faqArea && (scrollTop + windowHeight / 2 > faqTop);

    // נהל את הכפתור (אפור/כחול)
    if (scrolledEnough && reachedCards && !reachedFaq) {
      enableButton();
    } else {
      disableButton();
    }

    // נהל את הסטיקי (גלוי/נעלם)
    if (reachedFaq && stickyVisible) {
      stickyWrapper.style.opacity = '0';
      stickyWrapper.style.visibility = 'hidden';
      stickyWrapper.style.transform = 'translateY(100%)';
      stickyVisible = false;
      console.log('🚫 Sticky HIDDEN');
    } else if (!reachedFaq && !stickyVisible) {
      stickyWrapper.style.opacity = '1';
      stickyWrapper.style.visibility = 'visible';
      stickyWrapper.style.transform = 'translateY(0)';
      stickyVisible = true;
      console.log('👁️ Sticky VISIBLE');
    }
  }

  window.addEventListener('scroll', checkScroll);
  checkScroll();
  
  console.log('✅ Setup complete');
}
// משתנה גלובלי לזכירת המיקום בגלריה
window.currentGalleryIndex = 0;
window.allOriginalSlides = null;
window.allOriginalThumbs = null;

// פונקציה לסינון סליידים לפי צבע
function filterSlidesByColor(color) {
  console.log('🎨 Initial filter by color:', color);
  
  var allSlides = document.querySelectorAll('.Livia_gallery_swiper_main .swiper-slide');
  var visibleCount = 0;
  
  allSlides.forEach(function(slide) {
    var slideColor = slide.getAttribute('data-color');
    if (slideColor === color) {
      slide.style.display = '';
      if (!slide.classList.contains('swiper-slide-duplicate')) {
        visibleCount++;
      }
    } else {
      slide.style.display = 'none';
    }
  });
  
  return visibleCount;
}

// פונקציה לעדכון thumbnail פעיל
function updateActiveThumb(index) {
  var thumbs = document.querySelectorAll('.Livia_gallery_swiper_thumb .swiper-slide:not(.hidden-slide)');
  thumbs.forEach(function(thumb, i) {
    if (i === index) {
      thumb.classList.add('is-active');
    } else {
      thumb.classList.remove('is-active');
    }
  });
}

function LiviaAB_filterGalleryByColor(color) {
  console.log('🎨 Filtering gallery by color:', color);
  
  if (!window.mainSwiperInstance || !color) {
    console.log('❌ Missing instance or color');
    return;
  }
  
  if (!window.allOriginalSlides) {
    console.log('❌ No original slides saved!');
    return;
  }
  
  var currentIndex = window.mainSwiperInstance.realIndex || window.mainSwiperInstance.activeIndex || 0;
  
  // 1️⃣ הרס loop ישן
  if (window.mainSwiperInstance.params.loop) {
    window.mainSwiperInstance.loopDestroy();
  }
  
  // 2️⃣ נקה את ה-wrapper
  var mainWrapper = document.querySelector('.Livia_gallery_swiper_main .swiper-wrapper');
  mainWrapper.innerHTML = '';
  
  // 3️⃣ הוסף בחזרה רק slides מהצבע הנכון
  var visibleCount = 0;
  window.allOriginalSlides.forEach(function(slide) {
    var slideColor = slide.getAttribute('data-color');
    if (slideColor === color) {
      mainWrapper.appendChild(slide.cloneNode(true));
      visibleCount++;
    }
  });
  
  console.log('📊 Added', visibleCount, 'slides to gallery');
  
  // 4️⃣ אותו דבר ל-thumbnails
  if (window.thumbSwiperInstance && window.allOriginalThumbs) {
    var thumbWrapper = document.querySelector('.Livia_gallery_swiper_thumb .swiper-wrapper');
    thumbWrapper.innerHTML = '';
    
    window.allOriginalThumbs.forEach(function(slide) {
      var slideColor = slide.getAttribute('data-color');
      if (slideColor === color) {
        thumbWrapper.appendChild(slide.cloneNode(true));
      }
    });
  }
  
  // 5️⃣ בנה loop חדש
  window.mainSwiperInstance.params.loop = visibleCount > 1;
  
  if (visibleCount > 1) {
    window.mainSwiperInstance.loopCreate();
  }
  
  // 6️⃣ עדכן
  window.mainSwiperInstance.update();
  
  if (window.mainSwiperInstance.pagination) {
    window.mainSwiperInstance.pagination.render();
    window.mainSwiperInstance.pagination.update();
  }
  
  // 7️⃣ נווט
  var targetIndex = Math.min(currentIndex, visibleCount - 1);
  
  if (window.mainSwiperInstance.params.loop) {
    window.mainSwiperInstance.slideToLoop(targetIndex, 0);
  } else {
    window.mainSwiperInstance.slideTo(targetIndex, 0);
  }
  
  // 8️⃣ עדכן thumbnails
  if (window.thumbSwiperInstance) {
    window.thumbSwiperInstance.update();
    setupThumbClickEvents();
  }
  
  updateActiveThumb(targetIndex);
  
  console.log('✅ Filter complete!');
}

function setupThumbClickEvents() {
  console.log('🔧 Setting up thumb click events');
  
  // הסר אירועים קודמים ע"י שכפול האלמנטים
  var thumbSlides = document.querySelectorAll('.Livia_gallery_swiper_thumb .swiper-slide');
  
  thumbSlides.forEach(function(slide, index) {
    // הסר אירוע קודם
    var newSlide = slide.cloneNode(true);
    slide.parentNode.replaceChild(newSlide, slide);
  });
  
  // חבר מחדש
  thumbSlides = document.querySelectorAll('.Livia_gallery_swiper_thumb .swiper-slide');
  thumbSlides.forEach(function(slide, index) {
    slide.addEventListener('click', function() {
      console.log('👆 Thumb clicked, index:', index);
      
      // ⭐ תמיד השתמש ב-slideToLoop אם יש loop
      if (window.mainSwiperInstance.params.loop) {
        window.mainSwiperInstance.slideToLoop(index, 300);
      } else {
        window.mainSwiperInstance.slideTo(index, 300);
      }
      
      window.currentGalleryIndex = index;
      updateActiveThumb(index);
    });
  });
  
  console.log('✅ Thumb events ready for', thumbSlides.length, 'thumbs');
}

document.addEventListener('DOMContentLoaded', function () {
  console.log('DOM Ready - Initializing Livia');
  
  // -------- helpers --------
  function q(sel, root){ return (root||document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }

  function getActiveCard(){
    return q('.Livia_delivery_mode_switch.is-active') || q('.Livia_delivery_mode_switch.active');
  }

  function getActiveMode(){
    var card = getActiveCard();
    return card?.getAttribute('data') || card?.getAttribute('data-mode') || 'onetime';
  }

  // -------- sync button from active card --------
  function syncButtonFromActiveCard(){
    var btn  = q('#lv_tr_atc_one-time-purchase');
    var card = getActiveCard();
    if (!btn || !card) return;

    var mode  = card.getAttribute('data') || card.getAttribute('data-mode') || 'onetime';
    btn.setAttribute('data-mode', mode);

    if (mode === 'autodelivery') {
      var planId = card.getAttribute('data-plan-id') || card.getAttribute('data-value') || '';
      var sellId = card.getAttribute('data-selling-plan-id') || '';

      if (planId){
        btn.setAttribute('data-value', planId);
        btn.setAttribute('data-plan-id', planId);
      }
      if (sellId){
        btn.setAttribute('data-selling-plan-id', sellId);
      }
      if (!btn.getAttribute('data-subText-sub')){
        btn.setAttribute('data-subText-sub', 'Membership, Every 6 months');
      }
    } else {
      btn.removeAttribute('data-selling-plan-id');
      if (!btn.getAttribute('data-subText-onetime')){
        btn.setAttribute('data-subText-onetime', 'one-time');
      }
    }
  }

  // -------- images handling (KIT + SUB + fallback) --------
  var imgKit = q('#livia-card-img-onetime') || q('#livia-card-img');
  var imgSub = q('#livia-card-img-sub');
  var imgFb  = q('#lv-fallback-main-img');

  function updateImagesForCell(cell){
    if (!cell) return;

    var k = (cell.getAttribute('data-card-image-kit') || '').trim();
    var s = (cell.getAttribute('data-card-image-sub') || '').trim();
    if (!s) s = k;

    if (imgKit && k) imgKit.src = k;
    if (imgSub && s) imgSub.src = s;

    if (imgFb){
      var mode = getActiveMode();
      imgFb.src = (mode === 'autodelivery') ? (s || k) : (k || s);
    }
  }

  // -------- wire up: color cells --------
  var colorCells  = qa('.Livia_product_color_selector_cell');
  var modeSwitches = qa('.Livia_delivery_mode_switch');

  colorCells.forEach(function(cell){
    cell.addEventListener('click', function(){
      colorCells.forEach(function(c){
        c.classList.remove('is-active');
        c.classList.remove('active');
      });
      cell.classList.add('is-active');
      cell.classList.add('active');

      modeSwitches.forEach(function(sw){
        sw.classList.remove('pink', 'purple', 'lavender', 'blue-green');
      });

      var color = cell.getAttribute('data-title');

      if (color === 'blue-green') {
        modeSwitches.forEach(function(sw){ sw.classList.add('blue-green'); });
      } else if (color === 'pink') {
        modeSwitches.forEach(function(sw){ sw.classList.add('pink'); });
      } else if (color === 'lavender') {
        modeSwitches.forEach(function(sw){ sw.classList.add('lavender'); });
      } else if (color === 'purple') {
        modeSwitches.forEach(function(sw){ sw.classList.add('purple'); });
      }

      updateImagesForCell(cell);
      LiviaAB_filterGalleryByColor(color);
    });
  });

  // -------- wire up: tabs (delivery mode cards) --------
  var cards = qa('.Livia_delivery_mode_switch');
  cards.forEach(function(card){
    card.addEventListener('click', function(){
      cards.forEach(function(c){
        c.classList.remove('is-active');
        c.classList.remove('active');
      });
      card.classList.add('is-active');
      syncButtonFromActiveCard();

      var activeCell = q('.Livia_product_color_selector_cell.is-active') || colorCells[0];
      updateImagesForCell(activeCell);
    });
  });

  // -------- initial state --------
  var initialCell = q('.Livia_product_color_selector_cell.is-active') || colorCells[0];
  if (initialCell && !initialCell.classList.contains('is-active')){
    initialCell.classList.add('is-active');
  }
  updateImagesForCell(initialCell);
  syncButtonFromActiveCard();

  // ===== init gallery + countdown =====
  initLiviaABGallery();
  initLiviaABStripCountdown();
  initStickyBehavior();

  function initLiviaABGallery() {
    if (!window.Swiper) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      document.head.appendChild(css);

      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.onload = initAfterSwiper;
      document.body.appendChild(script);
      return;
    }
    initAfterSwiper();
  }
function initAfterSwiper() {
  console.log('Initializing Swiper');
  
  if (window.mainSwiperInstance) {
    window.mainSwiperInstance.destroy(true, true);
  }
  if (window.thumbSwiperInstance) {
    window.thumbSwiperInstance.destroy(true, true);
  }

  // ⭐ שמור את כל ה-slides לפני כל דבר!
  window.allOriginalSlides = Array.from(
    document.querySelectorAll('.Livia_gallery_swiper_main .swiper-slide')
  );
  
  if (window.innerWidth >= 1024) {
    window.allOriginalThumbs = Array.from(
      document.querySelectorAll('.Livia_gallery_swiper_thumb .swiper-slide')
    );
  }
  
  console.log('💾 Saved', window.allOriginalSlides.length, 'original slides');

  // ⭐ אתחל Swiper לפני הסינון
  window.mainSwiperInstance = new Swiper('.Livia_gallery_swiper_main', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false, // ⭐ התחל בלי loop
    speed: 300,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      init: function() {
        console.log('Main swiper initialized');
        document.querySelector('.Livia_product_whole.LiviaAB').classList.add('lv-dots-ready');
      },
      slideChange: function() {
        var newIndex = this.realIndex !== undefined ? this.realIndex : this.activeIndex;
        window.currentGalleryIndex = newIndex;
        console.log('Slide changed to:', newIndex);
        updateActiveThumb(newIndex);
      }
    }
  });

  if (window.innerWidth >= 1024) {
    window.thumbSwiperInstance = new Swiper('.Livia_gallery_swiper_thumb', {
      slidesPerView: 4,
      spaceBetween: 14,
      direction: 'vertical',
      freeMode: false,
      watchSlidesProgress: true,
    });
  }

  // ⭐ עכשיו סנן לפי הצבע הראשוני
  var initialCell = document.querySelector('.Livia_product_color_selector_cell.is-active');
  var initialColor = initialCell ? initialCell.getAttribute('data-title') : null;

  if (initialColor) {
    console.log('🎨 Initial color:', initialColor);
    LiviaAB_filterGalleryByColor(initialColor); // ⭐ ישר לכאן!
  }

  if (window.innerWidth >= 1024) {
    setupThumbClickEvents();
    updateActiveThumb(0);
  }
}

  function initLiviaABStripCountdown(){
    var strip = document.querySelector('.Livia_product_whole.LiviaAB .LiviaBF_strip');
    if (!strip) return;

    var deadlineStr = strip.getAttribute('data-deadline');
    if (!deadlineStr) {
      strip.style.display = 'none';
      return;
    }

    var deadline = new Date(deadlineStr).getTime();
    if (isNaN(deadline)) {
      strip.style.display = 'none';
      return;
    }

    var elH = strip.querySelector('.lv-timer-hours');
    var elM = strip.querySelector('.lv-timer-mins');
    var elS = strip.querySelector('.lv-timer-secs');
    if (!elH || !elM || !elS) return;

    function pad(n){ return n < 10 ? '0' + n : '' + n; }

    function tick(){
      var diff = deadline - Date.now();
      if (diff <= 0){
        elH.textContent = '00';
        elM.textContent = '00';
        elS.textContent = '00';
        return;
      }

      var totalSec = Math.floor(diff / 1000);
      var days  = Math.floor(totalSec / 86400);
      var hours = Math.floor((totalSec % 86400) / 3600);
      var mins  = Math.floor((totalSec % 3600) / 60);
      var secs  = totalSec % 60;

      elH.textContent = pad(days);
      elM.textContent = pad(hours);
      elS.textContent = pad(mins) + ':' + pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Livia_main_product_new_B"]) return;
  try {
    
/**
 * Livia product – sync button + images (KIT/SUB) + fallback image for old ATC
 */
document.addEventListener('DOMContentLoaded', function () {

  var root = document.querySelector('.Livia_product_whole.lvB'); // יכול להיות null
  if (!root) return;

  // prevent double init
  if (root.dataset.lvbInit === '1') return;
  root.dataset.lvbInit = '1';


  /* [B-CHANGE] enable B-only global css (breadcrumb/footer) */
  document.body.classList.add('lvB-page');

  // -------- helpers --------
  function q(sel, root){ return (root||document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }


  function getActiveCard(){
    // תומך גם ב-active וגם ב-is-active כדי לא לשבור קוד ישן
    return q('.Livia_delivery_mode_switch.is-active') || q('.Livia_delivery_mode_switch.active');
  }

  function getActiveMode(){
    var card = getActiveCard();
    return card?.getAttribute('data') || card?.getAttribute('data-mode') || 'onetime';
  }

  // -------- sync button from active card --------
  function syncButtonFromActiveCard(){
    var btn  = q('#lv_tr_atc_one-time-purchase');
    var card = getActiveCard();
    if (!btn || !card) return;

    var mode  = card.getAttribute('data') || card.getAttribute('data-mode') || 'onetime';
    btn.setAttribute('data-mode', mode);

    if (mode === 'autodelivery') {
      var planId = card.getAttribute('data-plan-id') || card.getAttribute('data-value') || '';
      var sellId = card.getAttribute('data-selling-plan-id') || '';

      if (planId){
        btn.setAttribute('data-value', planId);
        btn.setAttribute('data-plan-id', planId);
      }
      if (sellId){
        btn.setAttribute('data-selling-plan-id', sellId);
      }
      if (!btn.getAttribute('data-subText-sub')){
        btn.setAttribute('data-subText-sub', 'Membership, Every 6 months');
      }
    } else {
      // one-time
      btn.removeAttribute('data-selling-plan-id');
      if (!btn.getAttribute('data-subText-onetime')){
        btn.setAttribute('data-subText-onetime', 'one-time');
      }
    }
  }

  // -------- images handling (KIT + SUB + fallback) --------
  // ids אפשריים בגלריות הכרטיסיות:
  //  - KIT: #livia-card-img-onetime (או #livia-card-img כגיבוי)
  //  - SUB: #livia-card-img-sub
  //  - Fallback ישן לכפתור ה-ATC הישן: #lv-fallback-main-img
  var imgKit = q('#livia-card-img-onetime') || q('#livia-card-img'); // תמונת ה-KIT
  var imgSub = q('#livia-card-img-sub');                              // תמונת ה-SUB (אם קיימת)
  /* [B-CHANGE] unique fallback id */
  var imgFb  = document.getElementById('lv-fallback-main-img-{{ section.id }}');
          

  function updateImagesForCell(cell){
    if (!cell) return;

    // urls שמגיעים מה־data על תא הצבע
    var k = (cell.getAttribute('data-card-image-kit') || '').trim();
    var s = (cell.getAttribute('data-card-image-sub') || '').trim();
    if (!s) s = k; // אם אין תמונת מנוי ייעודית – נשתמש בזו של ה-KIT

    if (imgKit && k) imgKit.src = k;
    if (imgSub && s) imgSub.src = s;

    // לעדכן את ה-fallback לפי מצב הטאב הפעיל
    if (imgFb){
      var mode = getActiveMode();
      imgFb.src = (mode === 'autodelivery') ? (s || k) : (k || s);
    }
  }



// -------- wire up: color cells --------
var colorCells = qa('.Livia_product_color_selector_cell');
var modeSwitches = qa('.Livia_delivery_mode_switch');

colorCells.forEach(function(cell){
  cell.addEventListener('click', function(){

    // 1. active/is-active על כפתורי צבע
    colorCells.forEach(function(c){
      c.classList.remove('is-active');
      c.classList.remove('active');
    });
    cell.classList.add('is-active');
    cell.classList.add('active');

    // 2. צבע מסגרת של כרטיס המוצר
    modeSwitches.forEach(function(sw){
      sw.classList.remove('pink', 'purple', 'lavender', 'blue-green');
    });

    var color = cell.getAttribute('data-title'); // blue-green / pink / purple / lavender

    if (color === 'blue-green') {
      modeSwitches.forEach(function(sw){ sw.classList.add('blue-green'); });
    } else if (color === 'pink') {
      modeSwitches.forEach(function(sw){ sw.classList.add('pink'); });
    } else if (color === 'lavender') {
      modeSwitches.forEach(function(sw){ sw.classList.add('lavender'); });
    } else if (color === 'purple') {
      modeSwitches.forEach(function(sw){ sw.classList.add('purple'); });
    }

    // 3. עדכון תמונות כרטיס KIT/SUB
    updateImagesForCell(cell);

    // 4. סינון הגלריה לפי הצבע הנבחר
    if (window.jQuery && jQuery.fn && jQuery.fn.slick && color) {
      /* [B-CHANGE] scope slick to B root only */
      var $root  = jQuery(root);
      var $main  = $root.find('.Livia_product_gallery_main');
      var $thumb = $root.find('.Livia_product_gallery_thumb');

      if ($main.length && $main.hasClass('slick-initialized') &&
          $thumb.length && $thumb.hasClass('slick-initialized')) {

        $main.slick('slickUnfilter');
        $thumb.slick('slickUnfilter');

        /* [B-CHANGE] scope slides to B root only */
        $root.find('.Livia_product_gallery_slide').removeClass('Filtered_slide');
        $root.find('.Livia_product_gallery_slide').each(function(){
          if (color === jQuery(this).attr('data-color')) {
            jQuery(this).addClass('Filtered_slide');
          }
        });

        $main.slick('slickFilter', '.Filtered_slide');
        $thumb.slick('slickFilter', '.Filtered_slide');
        $main.slick('slickGoTo', 0);
      }
    }
  });
});



  // -------- wire up: tabs (delivery mode cards) --------
  var cards = qa('.Livia_delivery_mode_switch');
  cards.forEach(function(card){
    card.addEventListener('click', function(){
      cards.forEach(function(c){ c.classList.remove('is-active'); c.classList.remove('active'); });
      card.classList.add('is-active');
      syncButtonFromActiveCard();

      var activeCell = q('.Livia_product_color_selector_cell.is-active') || colorCells[0];
      updateImagesForCell(activeCell);

      // גלילה לכפתור STEP 3 עם ריווח
      var orderButton = root.querySelector('#lv_tr_atc_one-time-purchase');
      
      if (orderButton) {
        setTimeout(function () {
          var buttonTop = orderButton.offsetTop;
          var buttonHeight = orderButton.offsetHeight;
          var viewportHeight = window.innerHeight;
          
          // הכפתור יהיה 150px מהתחתית (תוכל לשנות את המספר)
          window.scrollTo({
            top: buttonTop + buttonHeight - viewportHeight + 10,
            behavior: 'smooth'
          });
        }, 200);
      }
    });
  });

  // -------- initial state --------
  // אם אין תא מסומן – נסמן את הראשון
  var initialCell = q('.Livia_product_color_selector_cell.is-active') || colorCells[0];
  if (initialCell && !initialCell.classList.contains('is-active')){
    initialCell.classList.add('is-active');
  }
  updateImagesForCell(initialCell);
  syncButtonFromActiveCard();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
window.onload = function() {

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
};

  } catch(e) { console.error(e); }
})();
})();
